export const lightTheme = {
  colors: {
    background: '#f5f5f5',
    cardBackground: '#fefefe',
    sidebarBackground: '#fefefe',
    text: '#000000',
    textSecondary: '#717182',
    border: '#00000033',
    sidebarBorder: '#e0dada',
    primary: '#000000',
    primaryForeground: '#ffffff',
    inputBackground: '#fefefe',
    shadow: '#d9cafb',
    shadowLight: '#ddd0fa',
    shadowInput: '#e4dbfb',
    blue: '#48b0ee',
  },
  landing: {
    background: '#ffffff',
    gradientFrom: '#BFDBFE',
    gradientVia: '#ffffff',
    gradientTo: '#BFDBFE',
    text: '#111827',
    textSecondary: '#383833',
    textMuted: '#9ca3af',
    navbarBg: 'rgba(255, 255, 255, 0.2)',
    navbarBorder: 'rgba(0, 0, 0, 0.1)',
    cardBg: '#ffffff',
    cardBorder: '#e5e7eb',
    buttonBg: '#3b82f6',
    buttonHover: '#2563eb',
    inputBg: '#ffffff',
    inputBorder: '#e5e7eb',
    iconBg: '#dbeafe',
    iconHover: '#bfdbfe',
    iconText: '#1f2937',
    linkColor: '#3b82f6',
    linkHover: '#2563eb',
    footerText: '#383833',
    errorColor: '#ef4444',
  },
  fonts: {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
  },
  fontSizes: {
    small: '12px',
    normal: '14px',
    medium: '16px',
    large: '18px',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '40px',
  },
  landingSpacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.5rem',
    xxl: '2rem',
    xxxl: '3rem',
  },
  borderRadius: {
    small: '8px',
    normal: '10px',
    medium: '15px',
    large: '20px',
    xlarge: '30px',
  },
  landingBorderRadius: {
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    xxl: '1.5rem',
    full: '9999px',
  },
  breakpoints: {
    mobile: '480px',
    tablet: '820px',
    desktop: '1024px',
    wide: '1440px',
  },
  landingBreakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },
};

export const darkTheme = {
  colors: {
    background: '#0a0a0a',
    cardBackground: '#1a1a1a',
    sidebarBackground: '#1a1a1a',
    text: '#fefefe',
    textSecondary: '#a0a0a0',
    border: '#FFFFFF33',
    sidebarBorder: '#2a2a2a',
    primary: '#E5E7EB',
    primaryForeground: '#000000',
    inputBackground: '#1a1a1a',
    shadow: 'rgba(107, 79, 187, 0.3)',
    shadowLight: 'rgba(138, 102, 204, 0.3)',
    shadowInput: 'rgba(138, 102, 204, 0.2)',
    blue: '#48b0ee',
  },
  landing: {
    background: '#111827',
    gradientFrom: '#1e3a8a',
    gradientVia: '#1f2937',
    gradientTo: '#1e3a8a',
    text: '#ffffff',
    textSecondary: '#d1d5db',
    textMuted: '#9ca3af',
    navbarBg: 'rgba(17, 24, 39, 0.4)',
    navbarBorder: 'rgba(255, 255, 255, 0.1)',
    cardBg: '#1f2937',
    cardBorder: '#374151',
    buttonBg: '#2563eb',
    buttonHover: '#1d4ed8',
    inputBg: '#111827',
    inputBorder: '#374151',
    iconBg: '#374151',
    iconHover: '#4b5563',
    iconText: '#ffffff',
    linkColor: '#60a5fa',
    linkHover: '#93c5fd',
    footerText: '#9ca3af',
    errorColor: '#ef4444',
  },
  fonts: {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
  },
  fontSizes: {
    small: '12px',
    normal: '14px',
    medium: '16px',
    large: '18px',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '40px',
  },
  landingSpacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.5rem',
    xxl: '2rem',
    xxxl: '3rem',
  },
  borderRadius: {
    small: '8px',
    normal: '10px',
    medium: '15px',
    large: '20px',
    xlarge: '30px',
  },
  landingBorderRadius: {
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    xxl: '1.5rem',
    full: '9999px',
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1440px',
  },
  landingBreakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },
};
